import React, { Component } from "react"
import OutsideClickTrigger from "../../../helpers/components/OutsideClickTrigger"
import formatCurrency from "../../../helpers/currencyHelper"
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"
import { isMobile } from "react-device-detect"
import userManager from "../../../helpers/userManager"
export default class TypeaheadOverlay extends Component {
  constructor(props) {
    super(props)
    const { filteredData, displayGroupNames, totalCount, config } = this.props.data
    this.state = {
      searchQuery: this.props.query ?? "",
      totalCount: totalCount ?? 0,
      filteredData: filteredData ?? {},
      displayGroupNames: displayGroupNames ?? [],
      queryBlocks: config?.queryBlocks ?? {},
      isSearchActive: false,
      searchBar: this.props.searchBar,
      onFinalizedSearch: this.props.onFinalSearch,
      overlayElem: this.props.elem,
    }
  }

  getCookieValue(cookieName) {
    const name = cookieName + "="
    const decodedCookie = decodeURIComponent(document.cookie)
    const cookieArray = decodedCookie.split(";")
    for (let cookie of cookieArray) {
      const trimmedCookie = cookie.trim()
      if (trimmedCookie.startsWith(name)) {
        return trimmedCookie.substring(name.length)
      }
    }
    return null
  }

  closeOverlay() {
    this.setState({ isSearchActive: false })
  }

  getSections(data, queryBlocks) {
    return this.state.totalCount > 0 ? (
      <div className="typeahead-overlay-content-inner">
        <Section
          key="resultCategories"
          data={data}
          queryBlocks={queryBlocks}
          sectionGroups={["brands", "categories"]}
          sectionName={"searchSectionTop"}
          className={"top"}
        />
        <Section
          key="resultProducts"
          data={data}
          queryBlocks={queryBlocks}
          onFinalSearch={this.state.onFinalizedSearch}
          sectionGroups={["products"]}
          sectionName={"searchSectionMiddle"}
          className={"middle"}
          searchQuery={this.state.searchQuery}
        />
        <Section
          key="resultBlogs"
          data={data}
          queryBlocks={queryBlocks}
          sectionGroups={["blogpages"]}
          sectionName={"searchSectionBottom"}
          className={"bottom"}
        />
      </div>
    ) : (
      ""
    )
  }

  render() {
    let data = this.state.filteredData
    let queryBlocks = this.state.queryBlocks
    if (this.state.isSearchActive) {
      return (
        <div className="typeahead-overlay-background">
          <OutsideClickTrigger onOutsideClick={() => this.closeOverlay()}>
            <div className="typeahead-overlay-content">
              <div onClick={() => this.closeOverlay()} className="close-typeahead-overlay cross"></div>
              <div id="overlaySearchForm">{this.state.searchBar}</div>
              {this.getSections(data, queryBlocks)}
            </div>
          </OutsideClickTrigger>
        </div>
      )
    } else {
      clearAllBodyScrollLocks()
      return ""
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props && this.props.data.filteredData !== undefined) {
      let scrollElem = document.getElementsByClassName("typeahead-overlay-content")[0]

      disableBodyScroll(scrollElem)
      const { filteredData, displayGroupNames, totalCount, config } = this.props.data
      this.setState({
        isSearchActive: true,
        filteredData: filteredData,
        displayGroupNames: displayGroupNames,
        totalCount: totalCount,
        queryBlocks: config.queryBlocks,
        searchQuery: this.props.query,
      })
    } else if (prevProps !== this.props) {
      this.setState({ isSearchActive: true, totalCount: 0 })
      let scrollElem = document.getElementsByClassName("typeahead-overlay-content")[0]
      disableBodyScroll(scrollElem)
    }
  }
}

class Section extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: this.props.searchQuery,
      onFinalizedSearch: this.props.onFinalSearch,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        searchQuery: this.props.searchQuery,
        onFinalizedSearch: this.props.onFinalSearch,
      })
    }
  }

  getProductPriceDom = (product) => {
    if (product.OnSale) {
      const listPrice = product.splash?.price?.listPrice?.amount || product.Price
      const effectivePrice = product.splash?.price?.effectivePrice?.amount || product.SpecialPrice
      const isClubDiscount = product.splash?.price?.isClubDiscountPriceType
      const clubPrice = product.PotentialClubPrice > 0 ? product.PotentialClubPrice : product.SpecialPrice
      if (effectivePrice < listPrice && !isClubDiscount) {
        return (
          <React.Fragment>
            <div id="onSalePrice" className="product-price discount">
              {formatCurrency(effectivePrice)} kr
            </div>
            <div id="onSalePriceOriginal" className="product-price-original">
              {formatCurrency(listPrice)} kr
            </div>
          </React.Fragment>
        )
      }
      // show the club price
      const clubPriceTeaser = userManager.isClubNeyeLoggedIn() ? "" : " club-teaser"
      return (
        <React.Fragment>
          <div id="onSalePrice" className="product-price discount" style={{ color: "#5BBAB7" }}>
            {formatCurrency(clubPrice)} kr
          </div>
          <div id="onSalePriceOriginal" className={"product-price-original" + clubPriceTeaser}>
            {formatCurrency(listPrice)} kr
          </div>
        </React.Fragment>
      )
    } else {
      return <div className="product-price">{formatCurrency(product.Price)} kr</div>
    }
  }

  getProductImageDom = (product) => {
    let firstImage
    let secondImage

    if (product.Images && product.Images.length > 0) {
      firstImage = product.Images[0]
      secondImage = product.Images[1]
    }

    if (!secondImage && firstImage) secondImage = firstImage
    return (
      <div className="product-image">
        <picture className="first-image">
          <source
            media="(max-width: 420px)"
            width="200"
            height="200"
            sizes="(max-width: 420px) 40vw"
            type="image/webp"
            data-srcset={firstImage + "?width=200&format=webp&height=200&bgcolor=fff 200w"}
          ></source>

          <source
            media="(max-width: 420px)"
            width="200"
            height="200"
            sizes="(max-width: 420px) 40vw"
            type="image/jpg"
            data-srcset={firstImage + "?width=200&height=200&bgcolor=fff 200w"}
          ></source>
          <source
            media="(min-wiby ldth: 421px)"
            width="300"
            height="300"
            sizes="(max-width: 766px) 50vw, (max-width: 768px) 33vw, (min-width: 988px) 20vw"
            type="image/webp"
            data-srcset={
              firstImage + "?width=300&format=webp&height=300&bgcolor=fff 430w," + firstImage + "?width=800&format=webp&height=800&bgcolor=fff 800w"
            }
          ></source>

          <source
            media="(min-width: 421px)"
            width="300"
            height="300"
            sizes="(max-width: 766px) 50vw, (max-width: 768px) 33vw, (min-width: 988px) 20vw"
            type="image/jpg"
            data-srcset={firstImage + "?width=300&height=300&bgcolor=fff 430w," + firstImage + "?width=800&height=800&bgcolor=fff 800w"}
          ></source>

          <img
            className="product-image"
            width="300"
            height="300"
            src={firstImage + "?=fff"}
            alt={"image of " + product.Name}
            title={"image of " + product.Name}
          ></img>
        </picture>
        <picture className="alt-image">
          <source
            media="(max-width: 420px)"
            width="200"
            height="200"
            sizes="(max-width: 420px) 40vw"
            type="image/webp"
            data-srcset={secondImage + "?width=200&format=webp&height=200&bgcolor=fff 200w"}
          ></source>

          <source
            media="(max-width: 420px)"
            width="200"
            height="200"
            sizes="(max-width: 420px) 40vw"
            type="image/jpg"
            data-srcset={secondImage + "?width=200&height=200&bgcolor=fff 200w"}
          ></source>
          <source
            media="(min-width: 421px)"
            width="300"
            height="300"
            sizes="(max-width: 766px) 50vw, (max-width: 768px) 33vw, (min-width: 988px) 20vw"
            type="image/webp"
            data-srcset={
              secondImage + "?width=300&format=webp&height=300&bgcolor=fff 430w," + secondImage + "?width=800&format=webp&height=800&bgcolor=fff 800w"
            }
          ></source>

          <source
            media="(min-width: 421px)"
            width="300"
            height="300"
            sizes="(max-width: 766px) 50vw, (max-width: 768px) 33vw, (min-width: 988px) 20vw"
            type="image/jpg"
            data-srcset={secondImage + "?width=300&height=300&bgcolor=fff 430w," + secondImage + "?width=800&height=800&bgcolor=fff 800w"}
          ></source>

          <img
            className="alt-image"
            loading="lazy"
            width="300"
            height="300"
            src={secondImage + "?width=300&height=300&bgcolor=fff"}
            alt={"second image of " + product.Name}
            title={"second image of " + product.Name}
          ></img>
        </picture>
      </div>
    )
  }

  renderResults = (sectionData, queryBlocks) => {
    let sectionClasses = !isMobile
      ? sectionData.length > 1 && sectionData.every((s) => s.docs !== undefined && s.docs.length > 0)
        ? "contentsection halfcolumn"
        : "contentsection"
      : "contentsection"
    let brandCount, categoriesCount
    const dom = sectionData.map((section) => {
      const docs = section.docs
      var brandSection = sectionData.filter((section) => section.displayGroupName === "brands")[0]
      var categoriesSection = sectionData.filter((section) => section.displayGroupName === "categories")[0]
      if (docs !== undefined && docs.length > 0) {
        var headerLabel = <h4>{queryBlocks[section.displayGroupName]?.headerLabel}</h4>
        switch (section.displayGroupName) {
          case "brands":
            brandCount = (brandSection && brandSection.count) || 0
            categoriesCount = (categoriesSection && categoriesSection.count) || 0

            if (!isMobile || (isMobile && brandCount > categoriesCount)) {
              return (
                <div className={sectionClasses}>
                  {headerLabel}
                  {docs.map((item) => {
                    return (
                      <a key={item.id} href={item.PageUrl}>
                        {item.Title}
                      </a>
                    )
                  })}
                </div>
              )
            } else {
              return ""
            }
          case "categories":
            brandCount = (brandSection && brandSection.count) || 0
            categoriesCount = (categoriesSection && categoriesSection.count) || 0

            if (!isMobile || (isMobile && categoriesCount >= brandCount)) {
              return (
                <div className={sectionClasses}>
                  {headerLabel}
                  {docs.map((item) => {
                    let catPath = item.CategoryPath.join(" > ")
                    catPath += ` (${item.ProductCount})`
                    return (
                      <a key={item.id} href={item.PageUrl}>
                        {catPath}
                      </a>
                    )
                  })}
                </div>
              )
            } else {
              return ""
            }
          case "blogpages":
            return (
              <div className={sectionClasses}>
                {headerLabel}
                {docs.map((item) => {
                  return (
                    <a key={item.id} href={item.PageUrl}>
                      {item.Title}
                    </a>
                  )
                })}
              </div>
            )
          case "products":
            return (
              <div className={sectionClasses}>
                {headerLabel}
                <div className="search-results row align-items-start product-grid">
                  {docs.map((item) => {
                    const splashHtml = item.splashHtml
                    return (
                      <div key={item.id} className="item product-tile col-12 col-sm-4">
                        {splashHtml && <div className="splash-html" dangerouslySetInnerHTML={{ __html: splashHtml }}></div>}
                        <a href={item.url}>{this.getProductImageDom(item)}</a>
                        <div className="product-text">
                          <div className="brand">{item.Brand}</div>
                          <div className="description">{item.Name}</div>
                          {this.getProductPriceDom(item)}
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="show-all-button col-12">
                  <button
                    onClick={() => this.state.onFinalizedSearch(this.state.searchQuery)}
                    id="searchShowAllButton"
                    className="grey col-lg-4 push-lg-4"
                  >
                    Vis alle (<span id="searchResultCount">{section.count}</span>)
                  </button>
                </div>
              </div>
            )
          default:
            return ""
        }
      }
      return ""
    })
    return dom
  }

  render() {
    const { data, sectionGroups, className, queryBlocks } = this.props
    const sectionData = sectionGroups.map((group) => data[group])

    // render no results
    if (sectionData.every((s) => s.docs.length === 0)) {
      return (
        <div className={className}>
          <div className={"item"}>
            <div className={"text"}></div>
          </div>
        </div>
      )
    }

    return this.renderResults(sectionData, queryBlocks)
  }
}
